import React from 'react'
import * as PropTypes from 'prop-types'
import {InferPropTypes} from '@modifi/typescript-utils'
import {H6, Paragraph} from '@modifi/ui'

import {CardWrapper, StyledRow} from './styles'
import {DefaultComponentWrapper} from '../common'
import LinkComponent from '../link-component'

import {ctaMapping as defaultCtaMapping} from '../constants'

const ctaMapping = defaultCtaMapping

const propTypes = {
  cards: PropTypes.arrayOf(
    PropTypes.shape({
      headline: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      topCtaType: PropTypes.string,
      topCtaLabel: PropTypes.string,
      topCtaUrl: PropTypes.string,
      topCtaOpenInNewTab: PropTypes.bool,
      bottomCtaType: PropTypes.string,
      bottomCtaLabel: PropTypes.string,
      bottomCtaUrl: PropTypes.string,
      bottomCtaOpenInNewTab: PropTypes.bool,
      showCard: PropTypes.bool,
    })
  ),
  backgroundColor: PropTypes.string,
}
const defaultProps = {
  cards: [],
  backgroundColor: undefined,
}

export type SimpleCardsProps = InferPropTypes<typeof propTypes, typeof defaultProps>

export const SimpleCards: React.FC<SimpleCardsProps> = ({cards, backgroundColor}) => (
  <DefaultComponentWrapper backgroundColor={backgroundColor}>
    <StyledRow justifyContent="center" alignItems="stretch">
      {cards?.map(card => (
        <CardWrapper
          showCard={card?.showCard!}
          key={`simple-card-${card?.headline}`}
          stickToTop={
            !card?.topCtaType && !card?.topCtaLabel && !card?.bottomCtaType && !card?.bottomCtaLabel
          }
        >
          <H6>{card?.headline}</H6>
          <Paragraph>{card?.description}</Paragraph>
          {card?.topCtaLabel && (
            <LinkComponent
              targetUrl={card?.topCtaUrl!}
              type={card?.topCtaType!}
              label={card?.topCtaLabel}
              openInNewTab={card?.topCtaOpenInNewTab!}
              ctaMapping={ctaMapping}
            />
          )}
          {card?.bottomCtaLabel && (
            <LinkComponent
              targetUrl={card?.bottomCtaUrl!}
              type={card?.bottomCtaType!}
              label={card?.bottomCtaLabel}
              openInNewTab={card?.bottomCtaOpenInNewTab!}
              ctaMapping={ctaMapping}
            />
          )}
        </CardWrapper>
      ))}
    </StyledRow>
  </DefaultComponentWrapper>
)

SimpleCards.propTypes = propTypes

SimpleCards.defaultProps = defaultProps

export default SimpleCards
